import Logo from '../UI/Logo/Logo'
import styles from './NavbarMain.module.css'

const NavbarMain = () => {
  return (
    <div className={styles.container}>
      <Logo isWhite />
    </div>
  )
}

export default NavbarMain
